import React from 'react';

import ErrorPage from './ErrorPage';

class ErrorBoundary extends React.Component<{children: React.ReactNode}, {error: Error | null}> {
    constructor(props: {children: React.ReactNode}) {
        super(props);
        this.state = {error: null};
    }

    static getDerivedStateFromError(error: Error) {
        return {error};
    }

    render() {
        const {error} = this.state;
        const {children} = this.props;
        return error ? <ErrorPage /> : children;
    }
}

export default ErrorBoundary;
